module.exports = __webpack_public_path__ + "static/media/Transaction 2.8da32dc2.svg";